import ReactDOM from "react-dom/client";
import { AppRouter } from "./router";
import { ToastContainer } from "react-toastify";
import "react-international-phone/style.css";
import "react-loading-skeleton/dist/skeleton.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <AppRouter />
    <ToastContainer limit={1} autoClose={3000} />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
